import {
  Box,
  CircularProgress,
  Link,
  Modal,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import WorkOrderButton from "../../../components/PdfButtons/WorkOrderButton";
import PackingListButton from "../../../components/PdfButtons/PackingListButton";
import { useTheme } from "@emotion/react";
import { toTwoDecimals } from "../../../components/NewDetail/calculations/utils";

const InvoiceTableRow = ({ onSelect, order, isPendingQuote = false }) => {
  const theme = useTheme();
  return (
    <TableRow hover sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
      <TableCell
        align="left"
        onClick={() => {
          onSelect(order);
        }}
      >
        {order.id}
      </TableCell>

      <TableCell align="left">
        {order.company && order.company.name ? order.company.name : ""}
      </TableCell>
      <TableCell
        align="left"
        onClick={() => {
          onSelect(order);
        }}
      >
        {order.project.name}
      </TableCell>

      <TableCell
        align="left"
        onClick={() => {
          onSelect(order);
        }}
      >
        {order.company.creditType}
      </TableCell>
      <TableCell
        align="left"
        onClick={() => {
          onSelect(order);
        }}
      >
        <Link sx={{ cursor: "pointer" }}>
          {order.invoiceId
            ? order.isPaid
              ? "Paid"
              : "Unpaid"
            : "Invoice Pending"}
        </Link>
      </TableCell>
      <TableCell
        align="left"
        onClick={() => {
          onSelect(order);
        }}
      >
        {moment(order.estimateApprovalDate).format("MM/DD/YY")}
      </TableCell>

      <TableCell align="left">${toTwoDecimals(order.outTheDoorCost)}</TableCell>
      {/* {!isPendingQuote && (
        <TableCell
          align="left"
          onClick={() => {
            onSelect(order);
          }}
        >
          {loadingInvoice ? (
            <CircularProgress sx={{ margin: "4px" }} />
          ) : (
            <Typography sx={{ textAlign: "right" }}>
              {invoice ? `$${invoice.Balance}` : "N/A"}
            </Typography>
          )}
        </TableCell>
      )} */}
      {/* {!isPendingQuote && (
        <TableCell
          align="left"
          onClick={() => {
            onSelect(order);
          }}
        >
          {loadingInvoice ? (
            <CircularProgress sx={{ margin: "4px" }} />
          ) : (
            <Typography sx={{ textAlign: "right" }}>
              {invoice
                ? `${moment(invoice.DueDate).format("MM/DD/YY")}`
                : "N/A"}
            </Typography>
          )}
        </TableCell>
      )} */}
    </TableRow>
  );
};

export default InvoiceTableRow;
